module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lead.sync_status == 'not_sync_ready') ? _c('div', {
    staticClass: "crm-status",
    class: 'crm-status-' + _vm.lead.sync_status + ' ' + _vm.lead.sync_disabled
  }, [_c('div', [_c('img', {
    staticClass: "info-icon",
    attrs: {
      "src": require("../../../../assets/info.svg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "missing-message"
  }, [_vm._v(_vm._s(_vm.$t('models.project_lead.sync_missing_fields')))]), _vm._v(" "), (_vm.missingFieldsString) ? _c('div', {
    staticClass: "crm-status--missing-fields missing-fields"
  }, [_c('span', [_vm._v(_vm._s(_vm.missingFieldsString))])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7368c31e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/leads/LeadUpdateCrmStatus.vue
// module id = 1944
// module chunks = 0